import {Component, Inject, OnDestroy, OnInit, Optional} from "@angular/core";
import {RouteService} from "../../../../services/route/route.service";
import {Subscription} from "rxjs";
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import moment from "moment/moment";
import {AdminService} from "../../../../services/admin/admin.service";
import * as FileSaver from "file-saver-es";
import {finalize} from "rxjs/operators";

@Component({
  selector: 'app-translations-download',
  templateUrl: './translations-download.component.html'
})
export class TranslationsDownloadComponent implements OnInit, OnDestroy {

  private _subs: Subscription[] = [];

  maxDate: string = moment().utc().toISOString();
  startDate: string = moment().utc().add(-1, 'month').toISOString();
  endDate: string = moment().utc().toISOString();
  isLoading = false;

  constructor(public dialogRef: MatDialogRef<TranslationsDownloadComponent>,
              @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
              public routeService: RouteService,
              private adminService: AdminService,) {}

  public ngOnInit(): void {
    this.dialogRef.disableClose = true;
    this._subs.push(this.dialogRef.backdropClick().subscribe(() => {
      this.close();
    }));
  }
  public ngOnDestroy(): void {
    this.routeService.replaceUrl('/app/admin/translations');
    this._subs.forEach(s => s.unsubscribe());
    this._subs = [];
  }

  public close(): void {
    this.dialogRef.disableClose = false;
    this.dialogRef.close();
  }

  public get isValid(): boolean {
    return !!this.startDate && !!this.endDate;
  }

  public download(): void {
    this.isLoading = true;
    const startDate = moment(this.startDate).format('YYYY-MM-DD');
    const endDate = moment(this.endDate).format('YYYY-MM-DD');
    this.adminService.downloadTranslations(startDate, endDate).pipe(
        finalize(() => this.isLoading = false)
      ).subscribe((data) => {
        const json = JSON.stringify(data, null, " ");
        const blob = new Blob([json], {type: "text/plain;charset=utf-8"});
        FileSaver.saveAs(blob, 'translations.json');
        this.close();
      });
  }

}
